import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceModule } from '@tc/resource';
import { ResultContentCardModule } from '../result-content-card/result-content-card.module';
import { ResultContentCardGenericComponent } from './result-content-card-generic.component';

@NgModule({
    imports: [
        CommonModule,
        ResourceModule,
        ResultContentCardModule
    ],
    exports: [ResultContentCardGenericComponent],
    declarations: [ResultContentCardGenericComponent]
})
export class ResultContentCardGenericModule {}
